import { render, staticRenderFns } from "./payment-success.vue?vue&type=template&id=5563a035&"
import script from "./payment-success.vue?vue&type=script&lang=js&"
export * from "./payment-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports